import { BasicUser } from '../../models/basic-user';

export class ApplyEventWorkflowAction {
  WorkflowActionID: number;
  Include: boolean = true;
  DueInDays: number = 0;
  OwnerUserID?: number | null;
  OwnerTypeID?: number | null;

  constructor(init?: Partial<ApplyEventWorkflowAction>) {
    this.WorkflowActionID = init?.WorkflowActionID ?? -1;
    this.Include = init?.Include ?? true;
    this.DueInDays = init?.DueInDays ?? 0;
    this.OwnerUserID = init?.OwnerUserID ?? null;
    this.OwnerTypeID = init?.OwnerTypeID ?? null;
  }
}

export class ApplyEventWorkflowRequest {
  EventID: number;
  WorkflowID: number;
  Actions: ApplyEventWorkflowAction[] = [];

  constructor(init?: Partial<ApplyEventWorkflowRequest>) {
    this.EventID = init?.EventID ?? -1;
    this.WorkflowID = init?.WorkflowID ?? -1;
    this.Actions = init?.Actions ?? [];
  }
}
